var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.501953,
    y: 4.86719,
    width: 4.2861,
    height: 4.2861,
    rx: 0.5,
    transform: "rotate(-90 0.501953 4.86719)",
    fill: "#F6F8F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.501953,
    y: 27.7285,
    width: 4.2861,
    height: 4.2861,
    rx: 0.5,
    transform: "rotate(-90 0.501953 27.7285)",
    fill: "#F6F8F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.22119,
    y: 27.7285,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 6.22119 27.7285)",
    fill: "#F6F8F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.21094,
    y: 22.0137,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 6.21094 22.0137)",
    fill: "#F6F8F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9302,
    y: 22.0137,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 11.9302 22.0137)",
    fill: "#F6F8F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2119,
    y: 16.3008,
    width: 4.2861,
    height: 4.2861,
    rx: 0.5,
    transform: "rotate(-90 16.2119 16.3008)",
    fill: "#F6F8F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9302,
    y: 10.5859,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 11.9302 10.5859)",
    fill: "#F6F8F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.21094,
    y: 10.5859,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 6.21094 10.5859)",
    fill: "#F6F8F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.22119,
    y: 4.86719,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 6.22119 4.86719)",
    fill: "#F6F8F9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9302,
    y: 16.3008,
    width: 4.2861,
    height: 2.8574,
    rx: 0.5,
    transform: "rotate(-90 11.9302 16.3008)",
    fill: "#F6F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedArrow);
export default __webpack_public_path__ + "static/media/dotted-arrow.e7deccbd826c5417a449eebda23c5c80.svg";
export { ForwardRef as ReactComponent };